import React, { useState } from 'react';
import { 
  Box, 
  Tabs, 
  Tab,
  Typography
} from '@mui/material';
import BalancesPage from './AnalyticsPage';
import CustodialExchangesPage from './CustodialExchangesPage';
import NonCustodialExchangesPage from './NonCustodialExchangesPage';
import WithdrawalAnalyticsPage from './WithdrawalAnalyticsPage';

const AnalyticsMenuPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, pt: 2 }}>
        <Typography variant="h4" gutterBottom>
          Аналитика
        </Typography>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange} 
          aria-label="analytics tabs"
        >
          <Tab label="Балансы" />
          <Tab label="Кастодиальные обмены" />
          <Tab label="Некастодиальные обмены" />
          <Tab label="Кастодиальные выводы" />
        </Tabs>
      </Box>

      {currentTab === 0 && <BalancesPage />}
      {currentTab === 1 && <CustodialExchangesPage />}
      {currentTab === 2 && <NonCustodialExchangesPage />}
      {currentTab === 3 && <WithdrawalAnalyticsPage />}
    </Box>
  );
};

export default AnalyticsMenuPage;
